import httpClient from '@/core/http/client.service';

const uploadCsv = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
    });

const fetchFileTypes = () => httpClient.get('api/v1/order/csv?_format=json&stage=1&r=' + Math.random()).then((res) => res);

const loadCsv = (uploadCode) => httpClient.get('api/v1/order/csv?_format=json&stage=2&uploadCode=' + uploadCode + '&r=' + Math.random()).then((res) => res);

const loadDefaults = () => httpClient.get('api/v1/order/csv?_format=json&stage=defaults&r=' + Math.random()).then((res) => res);

const processCsv = (uploadCode) => httpClient.get('api/v1/order/csv?_format=json&stage=3&uploadCode=' + uploadCode + '&r=' + Math.random()).then((res) => res);

const fetchCsvRowsForReview = (uploadCode) => httpClient.get('api/v1/order/csv?_format=json&stage=5&uploadCode=' + uploadCode + '&r=' + Math.random()).then((res) => res);

const getHeaders = (uploadCode) => httpClient.get('api/v1/order/csv?_format=json&stage=3&getHeaders=' + uploadCode + '&r=' + Math.random()).then((res) => res);

const getReviewHeaders = (uploadCode) => httpClient.get('api/v1/order/csv?_format=json&stage=5&uploadCode=' + uploadCode + '&getHeaders=1&r=' + Math.random()).then((res) => res);

const setHeaders = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const setSelectedCsvRows = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const setDiscardedCsvRows = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const processMarkedRows = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const processMatchedRows = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const submitRows = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const saveDefaults = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const saveDefaultsHeaders = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const saveDefaultSubstitutions = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const deleteDefaults = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const deleteDefaultSubstitutions = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const loadExplorer = (data) => httpClient.post('api/v1/order/csv?_format=hal_json', data, {
    headers: {
        'Content-Type': 'application/hal+json',
    },
});

const loadDefaultHeaders = () => httpClient.get('api/v1/order/csv?_format=json&stage=defaultsheaders&r=' + Math.random()).then((res) => res);

const loadDefaultSubstitutions = () => httpClient.get('api/v1/order/csv?_format=json&stage=defaultssubstitutions&r=' + Math.random()).then((res) => res);

const processCsvRowsForReview = (uploadCode) => httpClient.get('api/v1/order/validate/csv?_format=json&uploadCode=' + uploadCode + '&r=' + Math.random()).then((res) => res);

const fetchProcessedRows = () => httpClient.get('api/v1/order/process/csv?_format=json').then((res) => res);

const cancelCsvUpload = (uploadCode) => httpClient.get('api/v1/order/cancel/csv?_format=json&uploadCode=' + uploadCode + '&r=' + Math.random()).then((res) => res);

export default {
    fetchFileTypes,
    uploadCsv,
    processCsv,
    fetchCsvRowsForReview,
    getHeaders,
    getReviewHeaders,
    loadCsv,
    setSelectedCsvRows,
    setDiscardedCsvRows,
    processMarkedRows,
    processMatchedRows,
    submitRows,
    loadDefaults,
    saveDefaults,
    deleteDefaults,
    loadExplorer,
    setHeaders,
    loadDefaultHeaders,
    saveDefaultsHeaders,
    saveDefaultSubstitutions,
    loadDefaultSubstitutions,
    deleteDefaultSubstitutions,
    processCsvRowsForReview,
    fetchProcessedRows,
    cancelCsvUpload,
};
